const { default: styled } = require("styled-components");

const CircularProgressBarContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${props => props.size}px;
  height: ${props => props.size}px;
`;

const CircularProgressBarText = styled.span`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 800;
  color: rgb(31, 41, 55);
`;

const CircularProgressBar = ({ percentage = 0, color, size = 80, strokeWidth }) => {
  const center = size / 2;
  const radius = size * 0.375;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference * (1 - percentage / 100);

  return (
    <CircularProgressBarContainer size={size}>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        {/* Background circle */}
        <circle
          cx={center}
          cy={center}
          r={radius}
          fill="none"
          stroke="#F0F0F0"
          strokeWidth= {strokeWidth || 9}
        />
        {/* Progress circle */}
        <circle
          cx={center}
          cy={center}
          r={radius}
          fill="none"
          stroke={color}
          strokeWidth= {strokeWidth || 9}
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          strokeLinecap="round"
          transform={`rotate(-90 ${center} ${center})`}
        />
      </svg>
      <CircularProgressBarText>{percentage}%</CircularProgressBarText>
    </CircularProgressBarContainer>
  );
};

export default CircularProgressBar;